import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { SelectDecorator } from '../../components/SelectDecorator/SelectDecorator';
import { ADAPTIVE_SIZE, CanvasAppContext, CanvasAppContextProps } from '../common/typings';

import * as keyset from './CreativeSizesSelector.i18n';

const i18n = i18nFactory(keyset);

interface SizesSelectorProps {
    cls?: string;
    enabled: boolean;
    change: (sizes: string[]) => void;
    value: string[];
    dataProvider: string[];
}

const buttonSettings = { text: i18n('filter') };

export class CreativeSizesSelector extends React.PureComponent<SizesSelectorProps> {
    render() {
        const items = this.props.dataProvider.map((size: string) => {
            return {
                val: size,
                text: size === ADAPTIVE_SIZE ? i18n('adaptive') : size,
                key: size
            };
        });

        const dataProvider = [{ title: i18n('sizes-title'), items }];

        return (
            <CanvasAppContext.Consumer>
                {({ parent }: CanvasAppContextProps) => (
                    <SelectDecorator
                        disabled={!this.props.enabled}
                        cls={this.props.cls}
                        theme={'normal'}
                        type={'check'}
                        size={'s'}
                        items={dataProvider}
                        onChange={this.props.change}
                        width={'max'}
                        val={this.props.value}
                        button={buttonSettings}
                        popup={{
                            scope: parent || undefined
                        }}
                    />
                )}
            </CanvasAppContext.Consumer>
        );
    }
}
